export default __webpack_public_path__ + "static/media/crucible-tool.d407505f.jpg";